import 'babel-polyfill';

import setupBlockStyles from 'hellosign/common/style/blocks';

require('../../scss/style.scss');
require('intl');
require('common/utils/log-uncaught-promises');
require('common/logger/track-logger');

setupBlockStyles();

var Application = require('./application');

// for server-side rendering (lib/vendor/react-server) (CC)
global.Application = Application;
global.app = new Application();

// Accessing 'window' breaks node.js server-side rendering.
// We MUST use 'typeof' to check for its existence. -Chris
if (typeof window !== 'undefined') {
    window.app = global.app;
}

exports.components   = require('./components');
global.HfReactHelper = require('common/utils/hf-react-helper');
global.Validation    = require('common/validation');
global.React         = require('react');
global.ReactDOM      = require('react-dom');

// hack to expose HS components to the react server (CC)
global.HSComponents = exports.components;



/** WEBPACK FOOTER **
 ** ./src/hellosign/entry.js
 **/